import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12l3 0","key":"svg-0"}],["path",{"d":"M12 3l0 3","key":"svg-1"}],["path",{"d":"M7.8 7.8l-2.2 -2.2","key":"svg-2"}],["path",{"d":"M16.2 7.8l2.2 -2.2","key":"svg-3"}],["path",{"d":"M7.8 16.2l-2.2 2.2","key":"svg-4"}],["path",{"d":"M12 12l9 3l-4 2l-2 4l-3 -9","key":"svg-5"}]]

const IconClick = createReactComponent('outline', 'click', 'Click', __iconNode);

export default IconClick;